'use client';

import { type ReactElement, cloneElement, forwardRef, isValidElement, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellBannerRootContext } from './context/upsell-banner-root.context';
import { upsellBannerActionStyles } from './styles/upsell-banner-action.styles';
import type { UpsellBannerActionPropsInterface } from './types/upsell-banner-action.types';

/**
 * @since 10.0.0
 */
export const UpsellBannerAction = forwardRef<HTMLDivElement, UpsellBannerActionPropsInterface>(
  (props: UpsellBannerActionPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellBannerRootContext);
    const styles = css(upsellBannerActionStyles, cssProp);
    const onImpact = tone && ['hero', 'impact'].includes(tone);
    const content = isValidElement(children)
      ? cloneElement(children as ReactElement, { onImpact })
      : null;
    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="UpsellBanner.Action"
        className={cx('c11n', 'c11n_upsell-banner__action', styles, className)}
        {...rest}
      >
        {content}
      </div>
    );
  },
);

UpsellBannerAction.displayName = 'UpsellBanner.Action';
